import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

export type StatusMasterType = 'tenantStatuses' | 'subscriptionStatuses' | 'paymentStatuses' | 'featureFlagStatuses';

export interface StatusMasterListPayload {
  type: StatusMasterType;
  includeDeleted?: boolean;
  page?: number;
  limit?: number;
}

export interface StatusMasterFormPayload {
  status_code: string;
  status_name: string;
  colour_code: string;
  is_active_state?: boolean;
  display_order?: number;
  notes?: string;
}

const ENDPOINT_BY_TYPE: Record<StatusMasterType, string> = {
  tenantStatuses: API_ENDPOINTS.tenantStatuses,
  subscriptionStatuses: API_ENDPOINTS.subscriptionStatuses,
  paymentStatuses: API_ENDPOINTS.paymentStatuses,
  featureFlagStatuses: API_ENDPOINTS.featureFlagStatuses,
};

const list = (payload: StatusMasterListPayload) => {
  const { type, includeDeleted, page, limit } = payload;
  const params: Record<string, string> = {};
  if (includeDeleted) params.includeDeleted = 'true';
  if (page) params.page = String(page);
  if (limit) params.limit = String(limit);
  const query = new URLSearchParams(params).toString();
  return http.get(`${ENDPOINT_BY_TYPE[type]}${query ? `?${query}` : ''}`);
};

const get = (type: StatusMasterType, id: number | string) => {
  return http.get(`${ENDPOINT_BY_TYPE[type]}/${id}`);
};

const create = (type: StatusMasterType, payload: StatusMasterFormPayload) => {
  return http.post(ENDPOINT_BY_TYPE[type], payload);
};

const update = (type: StatusMasterType, id: number | string, payload: Partial<StatusMasterFormPayload>) => {
  return http.patch(`${ENDPOINT_BY_TYPE[type]}/${id}`, payload);
};

const remove = (type: StatusMasterType, id: number | string) => {
  return http.delete(`${ENDPOINT_BY_TYPE[type]}/${id}`);
};

const MasterService = { list, get, create, update, remove };

export default MasterService;
